// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { Matter, ProjectTemplateMatter } from "../../types";

const projectTemplateMattersModule = {
  async findByProjectTemplateId(projectTemplateId: string): Promise<ProjectTemplateMatter[]> {
    const result = await sql`
      SELECT * FROM project_template_matters
      WHERE project_template_id = ${projectTemplateId}
      ORDER BY position ASC, created_at ASC
    `;
    return (result || []) as ProjectTemplateMatter[];
  },

  async create(data: Omit<ProjectTemplateMatter, 'id' | 'created_at'>): Promise<ProjectTemplateMatter> {
    const result = await sql`
      INSERT INTO project_template_matters (project_template_id, matter_template_id, position)
      VALUES (${data.project_template_id}, ${data.matter_template_id}, ${data.position})
      RETURNING *
    `;
    return result[0] as ProjectTemplateMatter;
  },

  async delete(id: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM project_template_matters
      WHERE id = ${id}
    `;
    return result.count > 0;
  },

  async deleteByProjectTemplateId(projectTemplateId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM project_template_matters
      WHERE project_template_id = ${projectTemplateId}
    `;
    return result.count > 0;
  }
};

export type ProjectTemplateMattersModule = typeof projectTemplateMattersModule;

export function registerProjectTemplateMatters(db: { projectTemplateMatters?: ProjectTemplateMattersModule }) {
  db.projectTemplateMatters = projectTemplateMattersModule;
}

export { projectTemplateMattersModule as projectTemplateMatters };
